import React from 'react';
import { TagFilterProps } from './types/types';

export const TagFilter = ({ label, plans, onClick }: TagFilterProps) => {
  return (
    <>
      <button className="clear-filter-container tag-container" onClick={onClick} data-testid="tag-filter-test">
        <div className="plans-container">
          {plans ? (
            <>
              <p>{label}:</p>
              {plans.map((plan, index) => {
                return (
                  <p key={plan} className="plan">
                    {Boolean(index) === !plans[-1] ? 'e' : ''} {new Intl.NumberFormat().format(Number(plan))}
                  </p>
                );
              })}
            </>
          ) : (
            <p className="clear-filter">{label}</p>
          )}
        </div>
      </button>
    </>
  );
};
